import PropTypes from "prop-types"
import React from "react"
import Input from "semantic-ui-react/dist/es/elements/Input/Input"
import Label from "semantic-ui-react/dist/es/elements/Label/Label"
import "./TextInput.css"

const TextInput = props => {
  const iconProps = props.icon ? { icon: props.icon, iconPosition: "left" } : {}
  return (
    <div>
      <Input
        fluid
        name={props.name}
        value={props.initialValue}
        placeholder={props.placeholder}
        {...iconProps}
        action={props.action}
      />
      {props.hint ? <Label pointing>Help goes here!</Label> : ""}
    </div>
  )
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
  icon: PropTypes.string,
  hint: PropTypes.string,
  action: PropTypes.func
}

TextInput.defaultProps = {
  name: "input-comp-1"
}

export default TextInput
